import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

// Asks before leaving a page with unsaved changes: in-app navigation through
// the router's blocker, reload and tab close through beforeunload (the browser
// shows its own text there). Needs the data router set up in index.js.
const usePrompt = (message, when = true) => {
  const blocker = useBlocker(when);

  useEffect(() => {
    if (blocker.state !== 'blocked') {
      return;
    }
    if (window.confirm(message)) {
      blocker.proceed();
    } else {
      blocker.reset();
    }
  }, [blocker, message]);

  useEffect(() => {
    if (!when) {
      return;
    }
    const onBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [when]);
};

export default usePrompt;
